import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { ContaService } from '../services/conta.service';
import { MensagensService } from '../../constantes/mensagens.service';

import { ContaPermitida } from '../models/contaPermitida.model';
import { IDropDownConfig } from '../drop-down/drop-down.model';

@Component({
  selector: 'app-selecao-conta',
  standalone: false,
  templateUrl: './selecao-conta.component.html',
  styleUrls: ['./selecao-conta.component.css'],
})
export class SelecaoContaComponent implements OnInit {
  @Output() selecao: EventEmitter<string> = new EventEmitter<string>();

  contas: Array<ContaPermitida>;
  dropDownContaConfig: IDropDownConfig;
  selecaoAgenciaConta: string = null;
  mensagemValidacaoContas: string;
  labelDadosBancarios: string;
  exibirCarregamentoContas: boolean;

  constructor(private contaService: ContaService) {
    this.contas = new Array<ContaPermitida>();

    this.dropDownContaConfig = {
      dropDownId: 'dropDownContaOperador',
      idItem: 'contaOperadorItem',
      fieldSearch: 'codigoConta',
      placeholder: MensagensService.mensagens.selecaoContas.selecione,
    };
  }

  ngOnInit() {
    this.labelDadosBancarios =
      MensagensService.mensagens.selecaoContas.labelDadosBancarios;
    this.exibirCarregamentoContas = true;
    this.contaService.obterContasPermitidas().subscribe(
      (contasRecebidas) => {
        if (contasRecebidas !== null) {
          contasRecebidas.forEach((item) => {
            item.codigoConta = item.agencia + '/' + item.conta + '-' + item.dac;
          });

          contasRecebidas.sort(this.compare);

          this.mensagemValidacaoContas = null;
          this.exibirCarregamentoContas = false;
          this.contas = contasRecebidas;
        } else {
          this.exibirCarregamentoContas = false;
          this.mensagemValidacaoContas =
            MensagensService.mensagens.selecaoContas.erroListarContas;
          this.contas = new Array<ContaPermitida>();
        }
      },
      () => {
        this.exibirCarregamentoContas = false;
        this.mensagemValidacaoContas =
          MensagensService.mensagens.selecaoContas.erroListarContas;
      }
    );
  }

  recebeValorSelecionado(contaSelecionada: any) {
    if (this.selecaoAgenciaConta !== contaSelecionada) {
      if (contaSelecionada == null) {
        /**
         * se não tem conta selecionada, significa que o usuário deletou a conta do input
         * logo, a variável que armazena valor selecionado deve ser reinicializada
         */
        this.selecaoAgenciaConta = null;
        this.selecao.emit(this.selecaoAgenciaConta);
      } else {
        this.selecaoAgenciaConta = contaSelecionada;
        this.selecao.emit(this.selecaoAgenciaConta.replace(/(\.|\/|\-)/g, ''));
      }
    }
  }

  /**
   * Realiza a comparação entre agências para auxiliar na ordenação da lista de contas
   * @param a
   * @param b
   */
  compare(contaA: ContaPermitida, contaB: ContaPermitida) {
    if (contaA.codigoConta < contaB.codigoConta) {
      return -1;
    }
    return 1;
  }
}
